import BaseModelAPI from '../BaseModelAPI';

export default class StockOpnameResult extends BaseModelAPI {
	static entity = 'stockopnameresult';
	static entityName = 'stockopnameresult';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.stoResultNumber = '';
			this.id = '';
			this.stockOpnameId = '';
			this.stockOpname = {};
			this.fileUploadId = '';
			this.fileUpload = {};
			this.areaId = '';
			this.area = {};
			this.stockOpnamePlanId = '';
			this.stockOpnamePlan = {};
			this.totalQtySystem = 0;
			this.totalQtyActual = 0;
			this.totalDifferenceQty = 0;
			this.totalDifferencetPercentageQty = '';
			this.totalPriceQtySystem = 0;
			this.totalPriceQtyActual = 0;
			this.totalDifferencePrice = 0;
			this.stockOpnameResultDetail = []
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

	static async printExcelStoResult(this_, id) {
        let _this = this;
        return await this_.$http.get(`${this.entityName}/printExcelStoResult/${id}`)
			.then(async function(response){
				if (response.data) {
					await saveAs(response.data, _this.entityName + ".xlsx");
				}
				return null;	
			})
			.catch(function(error){
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
    }

}